module.exports = __webpack_public_path__ + "static/media/aboutImg.b5a38a92.jpg";